"use client";

import dynamic from "next/dynamic";

export const PhoneFrameBrowser = dynamic(
    () => import("./PhoneFrame")
        // this part is needed if your use a named export
        // you can replace by ".default" when using a default export
        .then((mod) => mod.PhoneFrame),
    {
        // This prevents server-side rendering of BrowserComponent
        ssr: false,
    }
);